import mutations from './contracts.mutations'
import actions from './contracts.actions'
import getters from './contracts.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
